// interface ISocialConfig {
//   twitter: string;
//   discord: string;
// }

const config = {
  adminPanel: 'https://argomedia.page.link/Student-Contest-Flyer',
  adminLogin: 'https://app.watchargo.com/creator/login?competition=1',
  xrm: 'https://www.xrmmedia.com/site ',
  buy: '#',
  twitter: 'https://twitter.com/Watch_Argo',
  discord: 'https://discord.gg/pemxqpYg9H',
  opensea: 'https://opensea.io/collection/argo-bad-assistant',
  instagram: 'https://www.instagram.com/watch.argo/',
  facebook: 'https://www.facebook.com/Argo-102195594802752/',
  tiktok: 'https://www.tiktok.com/@watch.argo',
  competition: 'https://web.watchargo.com/competition?competitionID=1',
  priceIncreaseInSeconds: 86400,
}

export default config;
